import { createContext } from 'preact';
import { useContext } from 'preact/hooks';

// The publisher's support email is provided once at each checkout flow root
// (the paywall and the item-purchase flow, which hold the resolved onsite
// config) and read by CheckoutShell to render an optional "contact the
// publisher" line on every step. A context keeps the value off every
// intermediate step component's prop list. Undefined means the publisher has
// not configured one, and the shell renders no line.
const SupportEmailContext = createContext<string | undefined>(undefined);

export const SupportEmailProvider = SupportEmailContext.Provider;

export function useSupportEmail(): string | undefined {
  return useContext(SupportEmailContext);
}
